import { useEffect, useState } from "react";
import { initEverflowSdk } from "src/lib/everflow";

export function useEverflowSdk() {
  const [loaded, setLoaded] = useState(
    () => typeof window !== "undefined" && !!window.EF?.click
  );
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      initEverflowSdk();
      if (window.EF?.click) {
        setLoaded(true);
        setError(null);
      } else {
        setError(new Error("Everflow SDK click metodu bulunamadı."));
      }
    } catch (e) {
      setError(e instanceof Error ? e : new Error(String(e)));
      setLoaded(false);
    }
  }, []);

  return { loaded, error };
}
